import classNames from "classnames";

import SimpleBar from 'simplebar-react';

import { EtfLabel } from 'shared/ui-kit';

import { IEtfCorrelationBackend } from 'api/correlations';

import { EftCorrelationPageTable } from './table';
import { EftCorrelationPageConnections } from './connections';

import styles from './content.module.scss';
import { useCallback, useContext, useState } from "react";
import { checkUserClaims } from "shared/auth";
import { UserClaims } from "shared/mechanics/auth";
import { AdsComponent } from 'shared/components/ads';
import { decodeSiteResolutionValue, SiteResolutionContext } from "shared/mechanics/site-resolution";

enum CurrencyType {
	RUB = "RUB",
	USD = "USD"
}

export interface EtfCorrelationPageContentProps {
	ticker: string;
	correlationsRub: IEtfCorrelationBackend[];
	correlationsUsd: IEtfCorrelationBackend[];
}

export const EtfCorrelationPageContent = (props: EtfCorrelationPageContentProps) => {
	const availableCurrencyTypes = [CurrencyType.RUB, CurrencyType.USD];

	const [currencyType, setCurrencyType] = useState<CurrencyType>(CurrencyType.RUB);

	const onCurrencyTypeChange = useCallback(
		(newCurrencyType: CurrencyType) => {
			checkUserClaims(UserClaims.HAVE_SUBSCRIPTION, "Валютные метрики в подписке", () => {
				setCurrencyType(newCurrencyType)
			});
		},
		[]);

	const correlationsMap = {
		[CurrencyType.RUB]: props.correlationsRub,
		[CurrencyType.USD]: props.correlationsUsd
	};
	const correlations = correlationsMap[currencyType];

	const siteResolution = useContext(SiteResolutionContext);
	const ads2Key = decodeSiteResolutionValue(siteResolution, 'InfoDetailedHorizontal2:desktop', 'InfoDetailedHorizontal2:mobile');

	return (
		<SimpleBar style={{ width: '100%', height: '100%' }}>
			<div className={classNames("flex-size-fill flex-container-vertical", styles.container)}>
				<div className={classNames("flex-size-least", "flex-container-horizontal", styles.header)}>
					<h1 className="flex-size-fill">Корреляции <EtfLabel ticker={props.ticker} /></h1>
					<div>
						<span className={styles.currency_label}>Валюта:</span>
						<select className={styles.currency_select} value={currencyType} onChange={e => onCurrencyTypeChange(e.currentTarget.value as CurrencyType)}>
							{
								availableCurrencyTypes.map(ct => <option value={ct}>{ct}</option>)
							}
						</select>
					</div>
				</div>
				<EftCorrelationPageConnections ticker={props.ticker} correlations={correlations} className={styles.item} />
				<div className={styles.item}>
					<AdsComponent id={ads2Key} isVertical={false} />
				</div>
				<EftCorrelationPageTable ticker={props.ticker} correlations={correlations} className={styles.item} />
			</div>
		</SimpleBar>
	);
}